import { render, staticRenderFns } from "./play.vue?vue&type=template&id=3723fb0e&"
import script from "./play.ts?vue&type=script&lang=ts&"
export * from "./play.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports